import React from 'react';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import TopBanner from '../components/TopBanner';
import Badge from '../components/Badge';

export default function AboutUs() {
    const homeimg = '/images/home/home.jpg';
    const server_url = process.env.REACT_APP_SERVER;

    const schemaData = {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "Lurantech",
        "url": `${server_url}`,
        "logo": `${server_url}/images/logo.png`,
        "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+91-7226-999-101",
            "contactType": "Customer Service",
            "areaServed": "IN, EU, AS",
            "availableLanguage": "English"
        },
        "sameAs": [
            "https://www.facebook.com/Lurantech-107968334690860",
            "https://www.linkedin.com/company/lurantech",
            "https://x.com/lurantech"
        ],
        "address": {
            "@type": "PostalAddress",
            "streetAddress": "FF-401, 4th Floor, 7 Sky Complex, Laxmipura, Near VUDA Cross Road",
            "addressLocality": "Vadodara",
            "addressRegion": "Gujarat",
            "postalCode": "390021",
            "addressCountry": "IN"
        },
        "description": "Lurantech is an enterprise business solutions provider founded in 2020, based in India. We offer innovative IT services globally with a focus on the latest technologies. Our skilled team of developers works with clients in Europe, Asia, and India to provide tailored solutions.",
        "foundingDate": "2020-01-01",
    };

    return (
        <>
            <HelmetProvider>
                <Helmet>
                    <meta property="og:title" content="Lurantech | About Us | Turning Ideas into Digital Reality" />
                    <meta property="og:description" content="Lurantech: Turning Ideas into Digital Reality" />
                    <meta property="og:image" content={`${server_url}${homeimg}`} />
                    <meta property="og:url" content="https://lurantech.com/about-us" />
                    <meta property="og:type" content="website" />
                    <meta property="og:image:type" content="image/jpeg" />
                    <meta property="og:image:width" content="1200" />
                    <meta property="og:image:height" content="675" />
                    <meta name="geo.position" content="22.3026;73.1812" />
                    <meta name="geo.placename" content="4th Floor - Office 1, 7, Sky Complex, Laxmipura, Vadodara, Gujarat 390021" />
                    <meta name="geo.region" content="IN-GJ" />
                    <meta property="og:latitude" content="22.3026" />
                    <meta property="og:longitude" content="73.1812" />
                    <meta property="og:location" content="4th Floor - Office 1, 7, Sky Complex, Laxmipura, Vadodara, Gujarat 390021" />

                    <meta name="twitter:title" content="Lurantech | About Us | Turning Ideas into Digital Reality" />
                    <meta name="twitter:description" content="Lurantech: Turning Ideas into Digital Reality" />
                    <meta name="twitter:image" content={`${server_url}${homeimg}`} />
                    <meta name="twitter:card" content="summary_large_image" />
                    <meta property="twitter:image:type" content="image/jpeg" />
                    <meta property="twitter:image:width" content="1200" />
                    <meta property="twitter:image:height" content="675" />

                    <meta name="robots" content="index, follow" />
                    <meta name="description" content="Lurantech is a leading enterprise business solutions provider, founded in 2020. Our team of expert developers is focused on delivering innovative IT services to clients in Europe, Asia, and India, leveraging the latest technologies." />
                    <meta name="keywords" content="liferay gujarat, liferay india, dxp cloud, liferay dxp, enterprise business solutions, IT services, innovative technologies, software development, global IT solutions, java, springboot, Liferay, Shopify, C++, Amazon web service, aws" />
                    <meta name="author" content="Lurantech" />

                    <link rel="canonical" href="https://lurantech.com/about-us" />
                    <link rel="preload" href={`${server_url}${homeimg}`} as="image" />
                    <title>Lurantech | About Us | Turning Ideas into Digital Reality</title>
                </Helmet>

                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{
                        __html: JSON.stringify(schemaData),
                    }}
                />

                <TopBanner title="Turning Ideas into Digital Reality" />

                {/* We Provide Section */}
                <div className='we-provide-container'>
                    <div className='we-provide-upper-con'>
                        <div className="row p-3 g-0">
                            <div className="col-12 col-sm-4 col-md-5 col-lg-5 col-xl-4">
                                <img alt="lurantech-solutions" className="we-provide-img" src="/images/about-us/we-provide-best.jpg" />
                            </div>
                            <div className="col-12 col-sm-1 col-md-1 col-lg-1 col-xl-1"></div>
                            <div className="col-12 col-sm-5 col-md-6 col-lg-6 col-xl-5">
                                <div className="we-provide-title">We Provide You Flexible Services</div>
                                <div className="we-provide-description">
                                    At Lurantech, we pride ourselves on offering dynamic and IT to suit your specific requirements. Our flexible approach means we can adjust our offerings to accommodate your evolving needs, when you require comprehensive IT infrastructure support, strategic consultancy, software development.
                                </div>
                            </div>
                            <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2"></div>
                        </div>
                    </div>

                    {/* Lower Cards Section */}
                    <div className='we-provide-lower-con'>
                        <div className="row">
                            <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                <div className='we-provide-card'>
                                    <div className="row we-provide-card-img">
                                        <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                            <img alt="lurantech-history" className="we-provide-sub-img" src="/images/about-us/our-history.png" />
                                            <div className='we-provide-sub-title'>Our History</div>
                                        </div>
                                        <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6"></div>
                                    </div>
                                    <div className='we-provide-sub-description'>
                                        Since 2020 we have been a visionary and a reliable software engineering partner for world-class brands. In a global space covering Europe and Asia.
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                <div className='we-provide-card'>
                                    <div className="row we-provide-card-img">
                                        <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                            <img alt="lurantech-mission" className="we-provide-sub-img" src="/images/about-us/our-mission.png" />
                                            <div className='we-provide-sub-title'>Our Mission</div>
                                        </div>
                                        <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6"></div>
                                    </div>
                                    <div className='we-provide-sub-description'>
                                        To drive success for our clients through unparalleled technical expertise, transformative digital experiences, and dedicated customer service.
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                <div className='we-provide-card'>
                                    <div className="row we-provide-card-img">
                                        <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                            <img alt="lurantech-vision" className="we-provide-sub-img" src="/images/about-us/our-vision.png" />
                                            <div className='we-provide-sub-title'>Our Vision</div>
                                        </div>
                                        <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6"></div>
                                    </div>
                                    <div className='we-provide-sub-description'>
                                        To be the leading provider of innovative, scalable, and reliable technological solutions that empower businesses to thrive in a rapidly evolving digital world.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* About Luran Section */}
                <div className='about-luran-container'>
                    <div className="row">
                        <div className="col-12 col-sm-5 col-md-5 col-lg-5 col-xl-5">
                            <img alt="lurantech-about" className="about-luran-img" src="/images/about-us/about.jpg" />
                        </div>
                        <div className="col-12 col-sm-7 col-md-7 col-lg-7 col-xl-5">
                            <div className="about-luran-title">About Luran..</div>
                            <div className="about-luran-description">
                                Luran is an enterprise business solution providing company based in India. We are privately held company founded in 2020. We are team of expert and skilled developers with innovative mindset. We focus on the latest technologies. We provide our services around the globe which covers Europe and Asia including India.
                            </div>
                        </div>
                        <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2"></div>
                    </div>
                </div>

                {/* Why Our Services Section */}
                <div className='why-our-container'>
                    <div className="row g-0">
                        <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2"></div>
                        <div className="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8">
                            <div className="why-our-title">
                                Why Our Services are Better?
                            </div>
                        </div>
                        <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2"></div>
                    </div>

                    <div className="row g-0 why-our-con-lower">
                        <Badge badgetitle="Quality Comes First" badgeimg="/images/about-us/quality-comes.png" />
                        <Badge badgetitle="Flexible Cooperation" badgeimg="/images/about-us/flexibal.png" />
                        <Badge badgetitle="On-time Delivery" badgeimg="/images/about-us/on-time.png" />
                        <Badge badgetitle="Qualified Developers" badgeimg="/images/about-us/qualified.png" />
                        <Badge badgetitle="Transparent Costs" badgeimg="/images/about-us/transparent.png" />
                        <Badge badgetitle="Quick Scale-up" badgeimg="/images/about-us/quick-scale.png" />
                    </div>
                </div>
            </HelmetProvider>
        </>
    );
};
